// extracted by mini-css-extract-plugin
module.exports = {"item":"_2r4OQ"};